import React, { useEffect, useState } from "react";
import { showFormErrors } from "../../../helpers/showFormErrors";
import CustomInput from "../../../components/form/CustomInput";
import CustomSelect from "../../../components/form/CustomSelect";
import CustomButton from "../../../components/form/CustomButton";
import { getStatuses } from "../../../helpers/configRoutes/backend_helper";
import { useDispatch } from "react-redux";
import { reset_stop } from "../../../store/loads/action";

const StepTowForm = ({
    validation,
    setNewStop
}) => {
    const dispatch = useDispatch()

    const [statuses, setStatuses] = useState([]);
    
    const resetStop = () => {
        validation.resetForm();
        dispatch(reset_stop())
        setNewStop(false)
    }

    useEffect(() => {
        const getCatalogs = async () => {
            const statusesResponse = await getStatuses({ params: { model: 'Stop' } });
            setStatuses(statusesResponse.statuses); // Descomentar si deseas actualizar los statuses de la API
        };
        getCatalogs();
    }, []);

    return (
        <form onSubmit={e => {
            e.preventDefault();
            validation.handleSubmit();
            showFormErrors(validation);
            return false;
        }}>
            <div className="grid grid-cols-2 gap-4 p-2">
                <CustomSelect
                    label="Status"
                    options={statuses}
                    name="status_id"
                    labelClassName={'text-base text-[#ADADAD]'}
                    className={'mr-2'}
                    error={validation?.errors?.status_id}
                    value={validation?.values?.status_id}
                    handleChange={(e) => {
                        const selectedStatus = statuses.find((s) => s.id === parseInt(e.target.value, 10));
                        validation.setFieldValue('status', selectedStatus);
                        validation.setFieldValue('status_id', e.target.value);
                    }}
                />
                <CustomInput
                    label="Mile"
                    type="text"
                    name="mile"
                    labelClassName="text-[14px] text-[#ADADAD] whitespace-nowrap"
                    error={validation?.errors?.mile}
                    value={validation?.values?.mile}
                    handleChange={validation.handleChange}
                />
                <div className="grid grid-cols-2 ">
                    <CustomInput
                        label="Load Date"
                        name="date"
                        type={'date'}
                        labelClassName="text-[14px] text-[#ADADAD] whitespace-nowrap"
                        error={validation?.errors?.date}
                        value={validation?.values?.date}
                        handleChange={validation.handleChange}
                    />
                    <CustomInput
                        label="Load Time"
                        name="load_time"
                        type={'time'}
                        labelClassName="text-[14px] text-[#ADADAD] whitespace-nowrap"
                        error={validation?.errors?.load_time}
                        value={validation?.values?.load_time}
                        handleChange={validation.handleChange}
                    />
                </div>
                <div className="grid grid-cols-2 ">
                    <CustomInput
                        label="Delivery Date"
                        name="delivery_date"
                        type={'date'}
                        labelClassName="text-[14px] text-[#ADADAD] whitespace-nowrap"
                        error={validation?.errors?.delivery_date}
                        value={validation?.values?.delivery_date}
                        handleChange={validation.handleChange}
                    />
                    <CustomInput
                        label="Delivery Time"
                        name="delivery_time"
                        type={'time'}
                        labelClassName="text-[14px] text-[#ADADAD] whitespace-nowrap"
                        error={validation?.errors?.delivery_time}
                        value={validation?.values?.delivery_time}
                        handleChange={validation.handleChange}
                    />
                </div>
            </div>
            <div className="flex items-center justify-center p-6 rounded-b border-slate-200">
                <CustomButton
                    type={"success"}
                    className="w-full lg:w-[20%]"
                >
                    Add Stop
                </CustomButton>

                <CustomButton
                    onClick={resetStop}
                    type={"button"}
                    className="w-full lg:w-[20%] bg-cs-danger"
                >
                    Cancel
                </CustomButton>
            </div>
        </form>
    )
}

export default StepTowForm